import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { MouseEvent } from 'react';
import { ExpenseFragmentFragment } from 'gql/index';
import { useIntl } from 'react-intl';
import { ExpenseDialog } from '../../Expenses/ExpenseDialog';
import { CostItemEntryType, QuoteEntry } from '../context/types';
import { QuoteDialog } from './QuoteDialog';

interface Props {
  open: boolean;
  onClose: () => void;
  costItemId?: number;
  type: CostItemEntryType;
  onTypeChange?: (type: CostItemEntryType) => void;
  allowTypeSwitch?: boolean;
  expense?: ExpenseFragmentFragment;
  quote?: QuoteEntry;
}

export const CostItemEntryDialog = ({
  open,
  onClose,
  costItemId,
  type,
  onTypeChange,
  allowTypeSwitch,
  expense,
  quote,
}: Props) => {
  const { formatMessage } = useIntl();

  const handleTypeChange = (_: MouseEvent<HTMLElement>, value: CostItemEntryType | null) => {
    if (!value || !onTypeChange) {
      return;
    }
    onTypeChange(value);
  };

  const entryTypeSwitcher = allowTypeSwitch && onTypeChange ? (
    <Stack alignItems='flex-start'>
      <ToggleButtonGroup value={type} exclusive onChange={handleTypeChange} size='small'>
        <ToggleButton value='expense'>
          {formatMessage({ id: 'Expense' })}
        </ToggleButton>
        <ToggleButton value='quote'>
          {formatMessage({ id: 'Quote' })}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  ) : undefined;

  return (
    <>
      <ExpenseDialog
        open={open && type === 'expense'}
        onClose={onClose}
        costItemId={costItemId}
        expense={expense}
        quoteId={quote?.id}
        entryTypeSwitcher={entryTypeSwitcher}
      />
      <QuoteDialog
        open={open && type === 'quote'}
        onClose={onClose}
        costItemId={costItemId}
        quote={quote}
        entryTypeSwitcher={entryTypeSwitcher}
      />
    </>
  );
};
